export enum TipusPublicacio {
  PSCP = "PLACSP",
  BOE = "BOE",
  DOUE = "DOUE",
  BOA = "BOA"
}
